






































import NoResults from "@/components/ui/NoResults.vue";
import { Component } from "vue-property-decorator";
import BaseInternalTableValorization
    from "@/components/pages/valorizations/internal/observatory/BaseInternalTableValorization.vue";

@Component({
  components: { NoResults }
})
export default class PatrimonialFloraBalanceTable extends BaseInternalTableValorization {
  protected url = "/valorization/observatory/flora/patrimonial-flora-balance";

  drawData() {
    this.data = this.data.length > 0 ? this.data : [];
  }
}
